import { Environment } from "shared";

const environmentsMap: Record<string, Environment> = {
  localhost: "localhost",
  dev: "sandbox",
  qa: "ci",
  mo: "preprod",
  hagerty: "production",
  // TODO: The following should be removed once we switch to using tenancy accounts.
  sandbox: "sandbox",
  ci: "ci",
  preprod: "preprod",
} as const;

const reInternalNonProd = /ap-spa-(dev|qa|mo)-(?:us|ca).member-engagement-non-prod.hagerty.com/;

/**
 * Gets the environment based on the hostname.
 * @param hostname The value of window.location.hostname
 * @returns The environment
 */
export const getEnvironment = (hostname: string): Environment => {
  let environment: Environment | undefined;

  // This will try to match on internal non-prod tenancy hostnames like "ap-spa-dev-us.member-engagement-non-prod.hagerty.com"
  const match = reInternalNonProd.exec(hostname);
  if (match) {
    environment = environmentsMap[match[1]];
  }

  if (!environment) {
    //TODO: This will need to be updated when we start using the new URL for the SPA.
    // If we're in prod the second segment is "hagerty".
    // ex: "account.hagerty.com" or "account.hagerty.ca"
    // Otherwise we're in non-prod
    // ex: "localhost" or "account.dev.hagerty.com" or "account.qa.hagerty.ca"
    const environmentKey = hostname.split(".")[1] || "localhost";
    environment = environmentsMap[environmentKey];
    // if environmentKey not found then throw
    if (!environment) throw new Error(`Unknown environment: ${environmentKey} in hostname: ${hostname}`);
  }

  return environment;
};
